import "./components/accessibility.js";
import "./components/animations.js";
import "./components/back-to-top.js";
import "./components/carousels.js";
import "./components/checkmark-list.js";
import "./components/cookie-consent.js";
import "./components/cover-videos.js";
import "./components/external-links.js";
import "./components/fixed-button.js";
import "./components/hover-reveal.js";
import "./components/inputs.js";
import "./components/lightboxes.js";
import "./components/notification-bar.js";
import "./components/mobile-menu.js";
import "./components/search-overlay.js";
import "./components/sticky-header.js";
import "./components/tabs.js";
import "./components/tooltips.js";
import "./components/trays.js";
import "./components/weather.js";

import "./a11y/gforms-autocomplete.js";

document.addEventListener("DOMContentLoaded", function () {
	if (true === window.bds_theme.debug.enabled) {
		console.log(bds_theme);
	}
});

document.addEventListener("click", function (event) {
	const trigger = event.target.closest(".donate-trigger");

	if (!trigger) {
		return;
	}

	event.preventDefault();

	if (
		typeof window.FundraiseUp === "undefined" ||
		typeof window.FundraiseUp.openCheckout !== "function"
	) {
		console.warn("Fundraise Up is not available.");
		return;
	}

	window.FundraiseUp.openCheckout("donate");
});
